import { render, staticRenderFns } from "./Morganizer.vue?vue&type=template&id=0c404967&scoped=true"
import script from "./Morganizer.vue?vue&type=script&lang=js"
export * from "./Morganizer.vue?vue&type=script&lang=js"
import style0 from "./Morganizer.vue?vue&type=style&index=0&id=0c404967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c404967",
  null
  
)

export default component.exports